import { configureStore } from '@reduxjs/toolkit';
import combineReducer from './reducer/combineReducer';

const store = configureStore({
  reducer: combineReducer,
});

export { store };
